/**
 * Mode « écran public » : masque les données financières sur tous les écrans.
 * État mémorisé par appareil (localStorage). Forcé à masqué pour les rôles sans droit financier.
 */
import { createContext, useContext, useState, useCallback } from 'react';
import { useAuth, canSeeFinancials } from './AuthContext';

const PublicModeContext = createContext(null);
const KEY = 'vd_public_mode';

export function PublicModeProvider({ children }) {
  const { user } = useAuth();
  const [stored, setStored] = useState(() => localStorage.getItem(KEY) === '1');

  // Un serveur (sans droit financier) est toujours en mode masqué.
  const forced = user ? !canSeeFinancials(user) : false;
  const isPublic = forced || stored;

  const toggle = useCallback(() => {
    setStored((prev) => {
      const next = !prev;
      localStorage.setItem(KEY, next ? '1' : '0');
      return next;
    });
  }, []);

  return (
    <PublicModeContext.Provider value={{ isPublic, forced, toggle }}>
      {children}
    </PublicModeContext.Provider>
  );
}

export function usePublicMode() {
  return useContext(PublicModeContext);
}
